export default "__VITE_ASSET__CIhnhWBG__"